/* global $:false */
(function() {
  "use strict";

  angular
    .module("admin.campaigns.promo.codes", [
      "admin.campaigns.promo.codes.edit",
      "admin.campaigns.promo.codes.service"
    ])
    .controller("PromoCodeCtrl", PromoCodeCtrl);

  /** @ngInject */
  function PromoCodeCtrl(
    $scope,
    $state,
    $stateParams,
    PromoService,
    PromoCodesService
  ) {
    var vm = this;
    vm.parentId = parseInt($stateParams.parentId);
    vm.promoId = parseInt($stateParams.promoId);
    vm.promo = {};
    vm.items = [];
    vm.pathImg = "";
    vm.load = false;
    vm.model = {};
    vm.totalUsers = 0;
    vm.usersPerPage = 15;
    vm.oldPage = 0;
    vm.currentPage = 15;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    vm.sortType = "id-asc";
    vm.sortReverse = true;

    load(1);

    var oldSortType;
    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 15;
        vm.oldPage = vm.currentPage - 15;
      } else {
        vm.first = false;
      }

      oldSortType = angular.copy(vm.sortType);
      PromoCodesService.list(
        vm.promoId,
        vm.oldPage,
        25,
        vm.sortType
      ).then(function(result) {
        PromoService.get(vm.promoId).then(function(resultPromo) {
        vm.promo = resultPromo.results;
          var items = result.results;
          if (vm.totalItems === 0) {
            vm.totalItems = result.ct;
          }

          for (var i = 0; i < items.length; i++) {
            items[i].promo = resultPromo.results;
          }

          vm.sortType = oldSortType;
          vm.items = items;
        });
      });
    }

    vm.pageChanged = function(newPage) {
      vm.sortType = oldSortType;
      load(newPage);
    };

    vm.back = function() {
      $state.go("admin.promo_campaigns.promo", { parentId: vm.parentId });
    };

    vm.add = function() {
      $state.go("admin.promo_campaigns.promo.codes.edit", { id: 0 });
    };

    vm.edit = function(item) {
      $state.go("admin.promo_campaigns.promo.codes.edit", { id: item.id });
    };

    vm.delete = function(item) {
      if (item["id-u"] !== null) {
        swal("Cannot delete redeemed promo codes", "", "error");
        return;
      }
      swal(
        {
          title: "Are you sure?",
          text: "",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top"
        },
        function(isConfirm) {
          if (isConfirm) {
            PromoCodesService.remove(item.id).then(function() {
              if (vm.items.length === 1 || vm.items.length === 25) {
                $state.reload();
              } else {
                vm.sortType = oldSortType;
                load(vm.pagination.current);
              }
            });
          } else {
            return;
          }
        }
      );
    };

    vm.sort = function(type) {
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + "-asc";
      } else {
        vm.sortType = type + "-desc";
      }
      load(vm.pagination.current);
    };
  }
})();
